<template>
  <form
    class="pax-form"
    @submit.prevent="submit"
  >
    <div class="row">
      <div class="pax-form-group col-4">
        <label for="_ident">Dni/Pasaporte</label>
        <div class="pax-form-input">
          <input
            autocomplete="off"
            type="text"
            class="pax-form-input"
            id="_ident"
            v-model="model.ident"
          >
        </div>
      </div>
      <div class="pax-form-group col-4">
        <label for="_surname">Apellido</label>
        <div class="pax-form-input">
          <input
            autocomplete="off"
            type="text"
            class="pax-form-input"
            id="_surname"
            v-model="model.surname"
          >
        </div>
      </div>
      <div class="pax-form-group col-4">
        <label for="_name">Nombre</label>
        <div class="pax-form-input">
          <input
            autocomplete="off"
            type="text"
            class="pax-form-input"
            id="_name"
            v-model="model.name"
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="pax-form-group col-4">
        <label for="_birthday">Fecha de nacimiento</label>
        <div class="pax-form-input">
          <cleave
            :options="{ date: true, datePattern: ['d', 'm', 'Y'] }"
            v-model="model.birthday"
            :raw="false"
          />
        </div>
      </div>
      <div class="pax-form-group col-4">
        <label>Sexo</label>
        <label
          for="_gender"
          class="pax-form-select"
        >
          <span class="pax-form-select-span">{{ model.gender }}</span>
          <select
            id="_gender"
            v-model="model.gender"
          >
            <option>Femenino</option>
            <option>Masculino</option>
          </select>
        </label>
      </div>
      <div class="pax-form-group col-4">
        <label>Nacionalidad</label>
        <label
          for="_nationality"
          class="pax-form-select"
        >
          <span class="pax-form-select-span">{{ model.nationality }}</span>
          <select
            id="_nationality"
            v-model="model.nationality"
          >
            <option
              v-for="(country, c) in COUNTRIES"
              :value="country"
              :key="c"
            >{{
              country
            }}</option>
          </select>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="pax-form-group col-4">
        <label for="_areacode">Codigo de area</label>
        <div class="pax-form-input">
          <input
            autocomplete="off"
            type="text"
            class="pax-form-input"
            id="_areacode"
            v-model="model.areacode"
            maxlength="4"
          >
        </div>
      </div>
      <div class="pax-form-group col-4">
        <label for="_tel">Teléfono</label>
        <div class="pax-form-input">
          <input
            autocomplete="off"
            type="text"
            class="pax-form-input"
            id="_tel"
            v-model="model.tel"
          >
        </div>
      </div>
      <div class="pax-form-group col-4">
        <label>Embarque</label>
        <label
          for="_boarding"
          class="pax-form-select"
        >
          <span class="pax-form-select-span">{{ boarding.name }}</span>
          <select
            id="_boarding"
            v-model="model.boarding_id"
          >
            <option
              v-for="(b, c) in boardings"
              :value="b.id"
              :key="c"
            >{{
              b.name
            }}</option>
          </select>
        </label>
      </div>
    </div>
    <div class="pax-form-group">
      <label>Observaciones</label>
      <div class="pax-form-input">
        <textarea
          rows="3"
          v-model="model.notes"
        />
      </div>
    </div>
    <div
      class="my-3"
      v-if="insurance && (model.insurance_old || model.insurance_outland)"
    >
      <label>Cobertura Medica incluida</label>
      <div class="mt-1">
        <span
          class="mr-3"
          v-if="model.insurance_old"
        >
          Abono para mayores de {{ insurance.age }}
          <strong>{{ departure.currency }}{{ model.insurance_old }}</strong> </span><br>
        <span
          class="mr-3"
          v-if="model.insurance_outland"
        >
          Abono por viaje al exterior
          <strong>{{ departure.currency }}{{ model.insurance_outland }}</strong>
        </span>
      </div>
    </div>
    <div class="pax-form-btns">
      <btn
        color="white"
        size="sm"
        class="xs-4"
        @click.prevent="$emit('close')"
      >
        CERRAR
      </btn>
      <btn
        color="orange"
        size="sm"
        class="xs-4"
      >
        GUARDAR
      </btn>
    </div>
  </form>
</template>

<script>
import Btn from '@/components/Btn'
import swal from 'sweetalert2'
import dayjs from 'dayjs'
import { post } from 'axios'
import { stringify } from 'qs'
import { COUNTRIES, API_ENDPOINT_BASE } from '@/constans'
import { clone } from '@/utils'
import { LOADING, RESERVATIONS } from '@/store/mutations'

const today = new Date()

export default {
  mounted () {
    if (!this.model.ident) {
      this.$el.querySelector('#_ident').focus()
    }
  },

  components: { Btn },

  props: ['value', 'departure'],

  computed: {
    cleave_options () {
      return {
        date: true,
        datePattern: ['d', 'm', 'Y'],
        dateMax: today.toISOString().split('T')[0]
      }
    },
    boardings () {
      return this.departure.boardings
    },
    insurance () {
      return this.departure.insurance
    },
    boarding () {
      return this.departure.boardings.find(i => i.id == this.model.boarding_id) || {}
    }
  },

  methods: {
    submit () {
      try {
        const reservation_id = this.value.reservation_id
        const model = clone(this.model)
        const borndate = model.birthday
          ? (([d, m, y]) => new Date([y, m, d]))(model.birthday.split('/'))
          : null

        if (/(infoas|minors)$/.test(model.type) && borndate) {
          const month = today.getMonth() - borndate.getMonth()
          let age = today.getFullYear() - borndate.getFullYear()

          if (today < borndate) {
            throw 'La fecha de nacimiento no es valida'
          }

          if (month < 0 || (month === 0 && today.getDate() < borndate.getDate())) {
            age = age - 1
          }

          if (this.departure.minors[model.type].age < age) {
            throw (
              'El pasajero "' +
							model.type_es +
							'" debe ser menor a ' +
							this.departure.minors[model.type].age +
							' años'
            )
          }
        }

        model.birthday = borndate ? dayjs(borndate).format('YYYY-MM-DD') : null

        if (model.name && model.surname) {
          model.alt = [model.surname, model.name].join(' ').trim()
        }

        const {
          ident,
          surname,
          name,
          gender,
          nationality,
          areacode,
          tel,
          birthday,
          boarding_id,
          notes,
          alt,
          insurance_old,
          insurance_outland
        } = model

        this.$store.commit(LOADING, true)

        post(
          API_ENDPOINT_BASE +
						'/reservations/' +
						reservation_id +
						'/passengers/' +
						model.id +
						'/edit',
          stringify({
            ident,
            surname,
            name,
            birthday,
            gender,
            nationality,
            areacode,
            tel,
            boarding_id,
            notes,
            alt,
            insurance_old,
            insurance_outland
          })
        )
          .then(({ data }) => {
            this.$store.commit(
              RESERVATIONS,
              this.$store.state.reservations.map(reservation => {
                if (reservation.id == reservation_id) {
                  reservation.passengers = reservation.passengers.map(pax => {
                    if (pax.id == data.id) {
                      Object.assign(pax, data)
                    }

                    return pax
                  })
                }
                return reservation
              })
            )
          })
          .catch(error => {
            error.response && swal({ html: error.response.data.msg, type: 'error' })
          })
          .finally(() => {
            this.$store.commit(LOADING, false)
            this.$emit('input', model)
          })
      } catch (e) {
        swal('', e + '', 'error')
      }
    }
  },

  data () {
    const model = clone(this.value)

    if (model.birthday) {
      model.birthday = dayjs(model.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }

    return {
      model,
      COUNTRIES
    }
  }
}
</script>
